import type { FaireProductEntity } from "../../entity_types/product";

export const p_bgwcfwj4cd: FaireProductEntity = {
  token: "p_bgwcfwj4cd",
  type: "product",
  name: "Oud Kit Trio Sabonetes Barra ",
  brandToken: "b_pvex8xjvw3",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/a276811bfb066658e0afb92e8593f5daf42aacf49ce16adf254b3b01de8fa246.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0794af9b116e8b3d7ce2b0eba01e0aa122b0d31d578e7556c9d7915ec21d162d.jpeg",
    "https://cdn.faire.com/fastly/b9eef1df8ed9adfe7165ace7e7a6047a65f7c8deb71c916b7a6ca96cacc4a85d.jpeg",
    "https://cdn.faire.com/fastly/5685e2723e06d54b51a05cdd3b707ad5efd68d83df3c0f0a13d6913ef88f0f8a.jpeg",
    "https://cdn.faire.com/fastly/a344f5ed8f39577d69510d52c48dd496547ce5f10153f16ba77c2783ab5ea950.jpeg",
  ],
  priceDollars: 18,
  description:
    "Oud offers an enveloping and aromatic interpretation of one of the rarest and most precious ingredients in perfumery. The fragrance explores rich woody nuances — including cedar, guaiac wood, and patchouli — harmonized with oriental, resinous, and spicy notes, creating a deep and sophisticated scent.\n\nThe Oud Bar Soap Set includes creamy bar soaps made with 76% ingredients of natural origin. The formula features a plant-based base, vegetable glycerin, murumuru butter, and coconut oil, ingredients that help hydrate the skin while gently cleansing, leaving it soft and delicately scented for longer.\n\nThe rigid box follows the visual identity of the Layering Collection, illustrated by Gabriel Azevedo. In addition to being a creative and sophisticated gift, the box can also be reused as a decorative object.\n\nFree from parabens and colorants. Not tested on animals.\n\nContents:\n3 Bar Soaps – 150 g (5.29 oz.) each\n\nGranado products are sold individually with a minimum order of 4 units per SKU. For every 6 units ordered of the same SKU, one complimentary tester unit will be included to support in-store sell-through.\n\nAll orders are fulfilled as open stock (not prepack), allowing retailers flexibility in building their assortment by SKU.\n\nIf you have any questions regarding testers or merchandising support, please reach out — we’re happy to assist.",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:35.289Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
